import React, { useState } from "react"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { MainContainer } from "../../components"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { useEdit } from "../../api/reactQueryCustomHooks"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Card, CardBody, CardFooter, Button, Input } from "@nextui-org/react"

function EditAdminMaster() {
  const navigate = useNavigate()

  const { selectedAdmin } = useSelector((state) => state.adminMaster)
  const [errors, setErrors] = useState({})

  const [formData, setFormData] = useState({
    adminId: selectedAdmin.adminId,
    username: selectedAdmin.username,
    password: "",
    confirm_password: "",
  })

  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)

  const onClickPrevPage = () => {
    navigate(linksUrl.adminMaster.read)
  }

  const onSuccessTasks = () => {
    navigate(linksUrl.adminMaster.read)
  }
  const resetValues = () => {}

  const { isPending, mutate: editAdminMaster } = useEdit({
    url: apiRoute.adminMaster.edit,
    queryKey: "AdminMaster",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    const newErrors = {}

    // Validate username
    if (formData.username.trim() === "") {
      newErrors.username = "Username Code is required"
    }

    // Validate password
    if (formData.password.trim() === "") {
      newErrors.password = "Password is required"
    }
    // Validate confirm_password
    if (formData.confirm_password.trim() === "") {
      newErrors.confirm_password = "Confirm Password is required"
    }

    // Validate confirm_password
    if (formData.password !== formData.confirm_password) {
      newErrors.confirm_password =
        "Confirm Password needs to be same same Password"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateForm()) {
      // Perform form submission logic here
      editAdminMaster({
        data: {
          adminId: formData.adminId,
          username: formData.username,
          password: formData.password,
          confirm_password: formData.confirm_password,
        },
      })
    }
  }

  return (
    <MainContainer
      breadcrumbs={["Admin Master", "Edit"]}
      pageName={"Edit Admin Master"}
      prevPage={{ show: true, onClick: onClickPrevPage }}
    >
      <Card className="max-w-[600px]" shadow="none" classNames="p-0">
        <form onSubmit={handleSubmit}>
          <CardBody className="p-0">
            <div className="flex flex-col gap-4 mx-2">
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  type="text"
                  label="Username"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.username}
                  errorMessage={errors?.username}
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  label="Password"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.password}
                  errorMessage={errors?.password}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  label="Confirm Password"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.confirm_password}
                  errorMessage={errors?.confirm_password}
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                />
              </div>
            </div>
          </CardBody>
          <CardFooter>
            <Button color="primary" type="submit" isLoading={isPending}>
              Edit Admin Master
            </Button>
          </CardFooter>
        </form>
      </Card>
    </MainContainer>
  )
}

export default EditAdminMaster
